import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgTagInputModule } from './tag-input';
import { NgDateInputsModule } from './date-inputs';
import { NgRadioButtonGroupComponent } from './radio-button-group';
import { NgCustomizableSliderModule } from './customizable-slider';
import { NgPasswordVisibilityComponent } from './password-visibility';
import { NgDialogsModule } from '../dialogs';
import { NgStylingComponentsModule } from '../../styling-components';
import { NgEventAnimationModule } from '../../animations';
import { NgDirectivesModule } from '../../directives';
import { NgRgbColorPickerComponent, NgRgbNamedColorPickerComponent } from './color-pickers';
import { NgCheckboxButtonGroupComponent, NgCheckboxMultiSelectDropdownComponent, NgCheckboxMultiSelectMenuComponent, NgRoundAnimatedCheckboxComponent } from './checkboxes';
import { NgImageComparisonModule } from './image-comparison/image-comparison.module';
import { NgPureDropdownComponent } from './pure-dropdown/pure-dropdown.component';


@NgModule({
	declarations: [
		NgCheckboxButtonGroupComponent,
		NgRgbColorPickerComponent,
		NgRgbNamedColorPickerComponent,
		NgRoundAnimatedCheckboxComponent,
		NgRadioButtonGroupComponent,
		NgCheckboxMultiSelectDropdownComponent,
		NgCheckboxMultiSelectMenuComponent,
		NgPasswordVisibilityComponent,
		NgPureDropdownComponent
	],
	imports: [
		CommonModule,
		NgbModule,
		FormsModule,
		NgDialogsModule,
		NgDirectivesModule,
		NgDateInputsModule,
		NgTagInputModule,
		ReactiveFormsModule,
		NgEventAnimationModule,
		NgImageComparisonModule,
		NgStylingComponentsModule
	],
	exports: [
		NgCheckboxButtonGroupComponent,
		NgRadioButtonGroupComponent,
		NgDateInputsModule,
		NgRgbColorPickerComponent,
		NgRgbNamedColorPickerComponent,
		NgRoundAnimatedCheckboxComponent,
		NgTagInputModule,
		NgCustomizableSliderModule,
		NgDialogsModule,
		NgCheckboxMultiSelectDropdownComponent,
		NgCheckboxMultiSelectMenuComponent,
		NgPasswordVisibilityComponent,
		NgDirectivesModule,
		NgImageComparisonModule,
		NgPureDropdownComponent
	]
})
export class NgInputsModule { }
